export default "__VITE_ASSET__CXCiy_lt__"